import ChargingState from './ChargingState';
import ChargingStatus from './enums/ChargingStatus';

export const isConnectorPluggedOn = (chargingState: ChargingState): boolean => {
    return chargingState.chargingStatus !== ChargingStatus.DISCONNECTED;
};
